var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "432.785px",
    height: "432.785px",
    viewBox: "0 0 432.785 432.785",
    style: {
      enableBackground: "new 0 0 432.785 432.785"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.103,432.785h138.581c6.902,0,12.5-5.596,12.5-12.5V298.182h122.102c6.904,0,12.5-5.597,12.5-12.5V147.104 c0-6.903-5.596-12.5-12.5-12.5H298.184V12.5c0-6.903-5.598-12.5-12.5-12.5H147.103c-6.904,0-12.5,5.597-12.5,12.5v122.104H12.5 c-6.904,0-12.5,5.597-12.5,12.5v138.578c0,6.903,5.596,12.5,12.5,12.5h122.103v122.104 C134.603,427.189,140.2,432.785,147.103,432.785z M25,273.182V159.604h122.103c6.903,0,12.5-5.597,12.5-12.5V25h113.581v122.104 c0,6.903,5.596,12.5,12.5,12.5h122.102v113.578H285.684c-6.904,0-12.5,5.598-12.5,12.5v122.104H159.603V285.682 c0-6.902-5.597-12.5-12.5-12.5H25z",
    fill: "#bbbbbb"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1c427905a995af91cdb4b5235ead0d08.svg";
export { ForwardRef as ReactComponent };